import React from 'react';
import { Checkbox } from '../../_components';

const FILTER_OPTIONS = [
  {
    name: 'events',
    displayName: 'Events',
    icon: null,
    id: 'chronos-search-filter_events',
  },
  {
    name: 'locations',
    displayName: 'Locations',
    icon: null,
    id: 'chronos-search-filter_locations',
  },
  {
    name: 'articles',
    displayName: 'Articles',
    icon: null,
    id: 'chronos-search-filter_articles',
  },
];

export function FilterMenu({
  filters,
  options = FILTER_OPTIONS,
  onChange,
  isDisabled,
}) {
  const handleFilterChange = (filter) => {
    if (isDisabled) return;
    if (onChange) onChange(filter);
  };

  return (
    <div className="chronos-global-search-options">
      {options &&
        options.map((option) => {
          return (
            <label key={option.id}>
              <span className="chronos-filter-label-text">
                {option.displayName}
              </span>
              <Checkbox
                value={filters.includes(option.name)}
                onChange={() => handleFilterChange(option.name)}
                disabled={isDisabled}
                custom
              />
            </label>
          );
        })}
    </div>
  );
}
